<template>
    <div>
        <div class="row">
            <div class="col-md-2">
                <div class="card mini-stats-wid">
                    <div class="card-body">
                        <div class="d-flex">
                            <div class="flex-grow-1">
                                <p class="text-muted fw-medium mb-2">Pending Authentications</p>
                                <h4 class="mb-0">{{ this.authentication_stats.pending_authentications }}</h4>
                            </div>
                            <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                <span class="avatar-title"><i class="bx bx-shield-quarter font-size-24"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="card mini-stats-wid">
                    <div class="card-body">
                        <div class="d-flex">
                            <div class="flex-grow-1">
                                <p class="text-muted fw-medium mb-2">Authenticated</p>
                                <h4 class="mb-0">{{ this.authentication_stats.authenticated }}</h4>
                            </div>
                            <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                <span class="avatar-title"><i class="bx bx-check-shield font-size-24"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="card mini-stats-wid">
                    <div class="card-body">
                        <div class="d-flex">
                            <div class="flex-grow-1">
                                <p class="text-muted fw-medium mb-2">Not Authenticated</p>
                                <h4 class="mb-0">{{ this.authentication_stats.not_authenticated }}</h4>
                            </div>
                            <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                <span class="avatar-title"><i class="bx bx-shield font-size-24"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-2">
                <div class="card mini-stats-wid">
                    <div class="card-body">
                        <div class="d-flex">
                            <div class="flex-grow-1">
                                <p class="text-muted fw-medium mb-2">Total Certificates</p>
                                <h4 class="mb-0">{{ this.authentication_stats.total_certificates }}</h4>
                            </div>
                            <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                <span class="avatar-title"><i class="bx bx-cube font-size-24"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="card mini-stats-wid">
                    <div class="card-body">
                        <div class="d-flex">
                            <div class="flex-grow-1">
                                <p class="text-muted fw-medium mb-2">Total Affidavits</p>
                                <h4 class="mb-0">{{ this.authentication_stats.total_affidavits }}</h4>
                            </div>
                            <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                                <span class="avatar-title"><i class="bx bx-pyramid font-size-24"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <CertificatePendingAuthenticationModal v-if="showModal_certificatePendingAuthenticationModal" @handleModal="handleModal" />

        <div class="row " v-for="agencyDetails in agency_certificates_for_vetting" :key="agencyDetails.agency">
            <div class="col-lg-12" v-if="agencyDetails.certificates_for_authentication.length > 0">
                <div class="card">
                    <div class="card-body">
                        <VettingTable
                            @handleModal="handleModal"
                            :agency="agencyDetails.agency"
                            :certificates="agencyDetails.certificates_for_authentication"
                            :remaining_quota="agencyDetails.remaining_quota"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VettingTable from "./tables/vettingTable.vue";
import { vettingComputed, vettingMethods } from "../../state/helpers";
import CertificatePendingAuthenticationModal from "./modals/certificatePendingAuthenticationModal.vue";

export default {
    //eslint-disable-next-line
    components: { VettingTable, CertificatePendingAuthenticationModal },
    data: () => ({
        showModal_certificatePendingAuthenticationModal: false,
        items: [
            { id: 1, name: "yes" },
            // { id: 2, name: "no" },
        ],
    }),
    computed: {
        ...vettingComputed,
    },
    methods: {
        ...vettingMethods,
        setModalFlag(modelName, flag) {
            //eslint-disable-next-line
            console.log("testing the flags", flag);
            if (modelName == "certificatePendingAuthenticationModal") {
                this.showModal_certificatePendingAuthenticationModal = flag;

                //eslint-disable-next-line
                console.log("the flag", this.showModal_certificatePendingAuthenticationModal);
            }
        },

        // this method handles the displaying of modals
        handleModal(modalName) {
            //eslint-disable-next-line
            console.log("goooi");
            //call the make the modals flag active
            this.setModalFlag(modalName, true);

            setTimeout(() => {
                //eslint-disable-next-line
                this.$bvModal.show(`${modalName}`);

                this.$root.$once("bv::modal::hide", (event) => {
                    if (event.type == "hide" && event.componentId == `${modalName}`) {
                        this.setModalFlag(modalName, false);
                    }
                });
            });
        },
    },

    mounted() {
        this.setCertificatesForVetting().then(() => {
            //eslint-disable-next-line
            // console.log(this.agency_certificates_for_vetting);

            for (let i = 0; i < this.agency_certificates_for_vetting.length; i++) {
                //eslint-disable-next-line
                console.log("hello", this.agency_certificates_for_vetting[i].agency);
            }

            //eslint-disable-next-line
            console.log("dd", this.authentication_stats);
        });
    },
};
</script>

<style lang="scss" scoped></style>
